import React from 'react';
import './becomeafreelancer.scss';
 

const   BecomeAfreelancer = () => {
    return (
        <>
           <div className="freelancer-rm-contianer">
                <div className="freelancer-rm-points">


                    <img src="image/rm-banner.png" alt="Freelancer working remotely on a freelancing job in India" />

                    <div className="freelancer-rm-content">
                        <h4>🎉 Introducing Relationship Manager</h4>
                        <h6>Always ready to help you with everything you need.</h6>
                        <button>RM : Prakash | <img src="/svg/phone.svg" alt="" /> +91 9625318281</button>

                    </div>
                </div>

            </div>
        </>
    );
}

export default BecomeAfreelancer;
